export default "__VITE_ASSET__5652244c__"